export default "__VITE_ASSET__B61d1xmR__"